const getApiErrorMessage = (error: any, fallbackMessage: string): string => {
  const responseMessage = error?.response?.data?.message;
  const validationErrors = error?.response?.data?.errors;

  if (validationErrors && typeof validationErrors === "object") {
    const flattened = Object.values(validationErrors).flat().filter(Boolean);
    if (flattened.length > 0) return flattened.join(", ");
  }

  if (responseMessage && typeof responseMessage === "string") {
    return responseMessage;
  }

  if (error?.message && typeof error.message === "string") {
    return error.message;
  }

  return fallbackMessage;
};

export default getApiErrorMessage;
